<div class="app-content filter">
    <div class="filter-header">
        <h2>Filter</h2>
        <span (click)="close()">
            <app-custom-icon
                [iconPath]="'assets/icons/general-icons.svg'"
                [imageName]="'icon-close'">
            </app-custom-icon>
        </span>
    </div>
    <mat-accordion>
        @if (filterForm | formControl: "individual"; as control) {
            <app-sidebar-filter-panel
                [title]="'Individual'"
                [controls]="[control]"
                [isEmpty]="!control.value">
                <app-select
                    [control]="control"
                    [optionList]="userList"
                    [showClear]="true"
                    [appendTo]="null"
                    [placeholder]="'Select Individual'"></app-select>
            </app-sidebar-filter-panel>
        }

        @if (showGroupFilters) {
            <app-group-filter-panels
                [filterForm]="filterForm"
                [options]="groupFilterOptions"></app-group-filter-panels>
        }

        @if (filterForm | formControl: "timeFrame"; as control) {
            <app-sidebar-filter-panel
                [title]="'Date Range'"
                [controls]="[control, filterForm | formControl: 'createdAt']"
                [isEmpty]="!control.value">
                <app-radio-list
                    [options]="timeFrameList"
                    [view]="'button-view'"
                    [direction]="'list-column'"
                    [currentSelection]="control.value"
                    (onChange)="setDateRangeValue(control, $event)"></app-radio-list>
            </app-sidebar-filter-panel>
        }
    </mat-accordion>

    <app-date-range-filter-modal
        [(visible)]="showDateRangeFilterModal"
        [control]="dateRangeFilterControl"
        (visibleChange)="onDateRangeFilterModalVisibleChange($event)" />
</div>
